import { MODIFIERS, MODIFIER_TYPES } from './production.constants'
import { BaseMachine } from './base'

function round (value, decimals = 2) {
  return Number(Math.round(value + 'e' + decimals) + 'e-' + decimals)
}

function fuzzyAmount () {
  return Math.floor(Math.random() * 10) / 2
}

const defaultState = {
  wins: 0,
  losses: 0,
  // draws: 0,
  streak: 0,
  followers: 0,
  popularity: 0,
  stamina: 0,
  charisma: 0,
  morale: 0,
  damage: 0,
  points: 75
}
export class Wrestler extends BaseMachine {
  constructor (props) {
    const model = Object.assign({}, defaultState, props)
    super(model)
    this.nextState = model
  }
  recordFuzz () {
    const values = this.nextState

    this.nextState.followers = round(values?.followers + fuzzyAmount(), 0)
    this.nextState.damage = round(values?.damage + fuzzyAmount())
    this.nextState.popularity = round(values?.popularity + fuzzyAmount())
    this.nextState.stamina = round(values?.stamina + fuzzyAmount())
    this.nextState.charisma = round(values?.charisma + fuzzyAmount())
    this.nextState.morale = round(values?.morale + fuzzyAmount())

    return this
  }
  recordWin () {
    const modifier = MODIFIERS[MODIFIER_TYPES.WIN]
    const values = this.nextState
    // tally
    this.nextState.wins += 1
    this.nextState.streak = values.streak + 1
    // positives
    this.nextState.followers = round(values?.followers + modifier.followers, 0)
    this.nextState.damage = round(values?.damage + modifier.damage, 0)
    this.nextState.popularity = round(values?.popularity + modifier.popularity)
    this.nextState.charisma = round(values?.charisma + modifier.charisma)
    this.nextState.morale = round(values?.morale + modifier.morale)
    this.nextState.points = values.points + 0.5
    // negatives
    this.nextState.stamina = round(values?.stamina - modifier.stamina)

    return this
  }
  recordLoss () {
    const modifier = MODIFIERS[MODIFIER_TYPES.LOSS]
    const values = this.nextState
    // tally
    this.nextState.losses = values.losses + 1
    this.nextState.streak = 0
    // positives
    this.nextState.followers = round(values.followers + modifier.followers, 0)
    this.nextState.damage = round(values.damage + modifier.damage, 0)
    this.nextState.points = values.points - 0.5

    this.nextState.charisma = values.charisma - modifier.charisma
    this.nextState.popularity = values.popularity - modifier.popularity
    this.nextState.stamina = values.stamina - modifier.stamina
    this.nextState.morale = values.morale - modifier.morale

    return this
  }
  recordDraw () {
    const modifier = MODIFIERS[MODIFIER_TYPES.DRAW]
    const values = this.nextState
    // tally
    // this.nextState.draws += 1
    // positives
    this.nextState.followers = round(values.followers + modifier.followers, 0)
    this.nextState.damage = round(values.damage + modifier.damage, 0)
    this.nextState.charisma = round(values.charisma + modifier.charisma)
    // negatives
    this.nextState.popularity = round(values.popularity - modifier.popularity)
    this.nextState.stamina = round(values.stamina - modifier.stamina)
    this.nextState.morale = round(values.morale - modifier.morale)
    return this
  }
  getState () {
    const levelFields = [
      'points',
      'charisma',
      'damage',
      'popularity',
      'morale',
      'stamina'
    ]

    levelFields.forEach(field => {
      if (this.nextState[field] > 100) {
        this.nextState[field] = 100
      }
    })
    return { ...this.nextState }
  }
}

export default Wrestler
